var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearch = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1188 22.2377C13.5858 22.2372 15.9817 21.4113 17.9249 19.8916L24.0347 26.0014L26 24.0361L19.8902 17.9263C21.4107 15.9829 22.2371 13.5864 22.2377 11.1188C22.2377 4.98819 17.2495 0 11.1188 0C4.98819 0 0 4.98819 0 11.1188C0 17.2495 4.98819 22.2377 11.1188 22.2377ZM11.1188 2.77971C15.7179 2.77971 19.458 6.51981 19.458 11.1188C19.458 15.7179 15.7179 19.458 11.1188 19.458C6.5198 19.458 2.77971 15.7179 2.77971 11.1188C2.77971 6.51981 6.5198 2.77971 11.1188 2.77971Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0814 9.15358C13.6081 9.68172 13.8986 10.3794 13.8986 11.1188H16.6783C16.6795 10.3884 16.536 9.66489 16.2559 8.99025C15.9758 8.3156 15.5648 7.70316 15.0466 7.18832C12.9424 5.08686 9.29401 5.08686 7.19116 7.18832L9.15364 9.15636C10.2099 8.10285 12.0306 8.10563 13.0814 9.15358Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/search.d90a335e7c98bb03c40ebb573b1af180.svg";